var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroImgs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 51,
    viewBox: "0 0 53 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5054 23.1438C29.5054 22.5142 28.993 22.0018 28.3625 22.0018C27.7338 22.0018 27.2213 22.5142 27.2213 23.1438C27.2213 23.7726 27.7338 24.2851 28.3625 24.2851C28.993 24.2851 29.5054 23.7726 29.5054 23.1438Z",
    fill: "url(#paint0_linear_2367_2328)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6774 22.3222L39.8427 17.4151L42.6774 12.508H48.3446L51.1777 17.4151L48.3446 22.3222H42.6774Z",
    fill: "url(#paint1_linear_2367_2328)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4709 11.2064L19.1685 7.22544L21.4709 3.24359H26.0657L28.3656 7.22544L26.0657 11.2064H21.4709Z",
    fill: "url(#paint2_linear_2367_2328)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3662 4.46792L48.1569 2.36985L49.3662 0.273438H51.7882L53 2.36985L51.7882 4.46792H49.3662Z",
    fill: "url(#paint3_linear_2367_2328)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2695 7.20633L36.3259 3.84078L38.2695 0.473572H42.1542L44.0994 3.84078L42.1542 7.20633H38.2695Z",
    fill: "url(#paint4_linear_2367_2328)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8382 34.8875L37.0011 41.7224L39.7636 42.4815L46.7364 30.4056L44.2438 26.089H40.1681L35.1231 17.3504L37.1606 13.8204L35.0534 10.1691H31.1338L28.3513 14.9857H19.1849L16.405 10.1691H11.6831L7.63727 17.1776L12.9506 25.4271C12.9971 25.4254 13.0394 25.4129 13.0868 25.4129C14.6591 25.4129 15.9407 26.6929 15.9407 28.2668C15.9407 29.8416 14.6599 31.1216 13.0868 31.1216C11.5128 31.1216 10.2329 29.8416 10.2329 28.2668C10.2329 27.5766 10.4904 26.952 10.899 26.4578L6.35068 19.4061L0 30.4048L6.13059 41.0239L19.003 32.5552L20.6127 26.6954L20.9923 26.4595C20.9923 26.4595 25.416 23.7119 25.5597 23.6238C25.5323 23.4669 25.5099 23.3082 25.5099 23.1446C25.5099 21.5706 26.7907 20.2907 28.363 20.2907C29.9378 20.2907 31.2185 21.5706 31.2185 23.1446C31.2185 24.7186 29.9378 25.9985 28.363 25.9985C27.7791 25.9985 27.2342 25.8199 26.7807 25.5168C26.6121 25.653 26.4335 25.7693 26.2881 25.859L22.5787 28.1605L20.9707 34.0129L7.27597 43.0048L10.4546 48.5116L21.3453 41.6277C21.3437 41.5837 21.3312 41.5413 21.3312 41.4973C21.3312 39.9233 22.6128 38.6426 24.1843 38.6426C25.7582 38.6426 27.0382 39.9233 27.0382 41.4973C27.0382 43.0696 25.7574 44.3504 24.1843 44.3504C23.4924 44.3504 22.8636 44.0929 22.3694 43.6801L11.5959 50.4901L11.6831 50.6421H35.0517L38.5825 44.5248L35.5351 43.6867L35.2984 43.3088C35.2984 43.3088 30.6878 35.7538 30.6014 35.6176C30.4453 35.6441 30.2858 35.6666 30.1221 35.6666C28.5507 35.6666 27.2691 34.3858 27.2691 32.8127C27.2691 31.2379 28.5498 29.9579 30.1221 29.9579C31.6969 29.9579 32.9761 31.2379 32.9761 32.8127C32.9761 33.3966 32.7991 33.9406 32.496 34.3949C32.6322 34.5644 32.7477 34.7429 32.8382 34.8875Z",
    fill: "url(#paint5_linear_2367_2328)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3248 41.4979C25.3248 40.8683 24.814 40.3558 24.1836 40.3558C23.5548 40.3558 23.0424 40.8683 23.0424 41.4979C23.0424 42.1267 23.5548 42.6383 24.1836 42.6383C24.8132 42.6383 25.3248 42.1267 25.3248 41.4979Z",
    fill: "url(#paint6_linear_2367_2328)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2271 28.2685C14.2271 27.6397 13.7146 27.1281 13.0859 27.1281C12.4555 27.1281 11.943 27.6397 11.943 28.2685C11.943 28.8989 12.4555 29.4105 13.0859 29.4105C13.7146 29.4105 14.2271 28.8989 14.2271 28.2685Z",
    fill: "url(#paint7_linear_2367_2328)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9797 32.8148C28.9797 33.4444 29.493 33.956 30.121 33.956C30.7514 33.956 31.2647 33.4444 31.2647 32.8148C31.2647 32.1852 30.7514 31.6736 30.121 31.6736C29.493 31.6736 28.9797 32.1852 28.9797 32.8148Z",
    fill: "url(#paint8_linear_2367_2328)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2367_2328",
    x1: 28.3633,
    y1: 22.9839,
    x2: 28.3633,
    y2: 47.6534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5FEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2367_2328",
    x1: 45.51,
    y1: 16.7297,
    x2: 45.51,
    y2: 122.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5FEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2367_2328",
    x1: 23.7669,
    y1: 6.66888,
    x2: 23.7669,
    y2: 92.7024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5FEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2367_2328",
    x1: 50.5784,
    y1: 2.07773,
    x2: 50.5784,
    y2: 47.3964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5FEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2367_2328",
    x1: 40.2125,
    y1: 3.36972,
    x2: 40.2125,
    y2: 76.1129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5FEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2367_2328",
    x1: 23.3674,
    y1: 27.5789,
    x2: 23.3674,
    y2: 464.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5FEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2367_2328",
    x1: 24.1835,
    y1: 41.3377,
    x2: 24.1835,
    y2: 65.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5FEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2367_2328",
    x1: 13.085,
    y1: 28.1099,
    x2: 13.085,
    y2: 52.7704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5FEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2367_2328",
    x1: 30.1222,
    y1: 32.6554,
    x2: 30.1222,
    y2: 57.3159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5FEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImgs);
export default __webpack_public_path__ + "static/media/HeroImgs.3765b95f1077c96e53e267c4c1276611.svg";
export { ForwardRef as ReactComponent };